import * as A from "fp-ts/Array";
import { pipe } from "fp-ts/function";
import {
  CollapsibleListData_Direction,
  CollapsibleListData_InitialExpandedItems,
  Node_Type
} from "./../../ricos-schema/legacy/wix/rich_content/v1";
import { addNode } from "./builder-utils";
import { createNode, DEFAULT_CONTAINER_DATA } from "./node-builder-methods";
const DEFAULT_COLLAPSIBLE_LIST_DATA = {
  initialExpandedItems: CollapsibleListData_InitialExpandedItems.FIRST,
  direction: CollapsibleListData_Direction.LTR,
  containerData: DEFAULT_CONTAINER_DATA,
  expandOnlyOne: false
};
const toCollapsibleItemNode = (generateId) => (item) => createNode(
  generateId
)(Node_Type.COLLAPSIBLE_ITEM, {}, [
  createNode(generateId)(
    Node_Type.COLLAPSIBLE_ITEM_TITLE,
    {},
    item.title.nodes
  ),
  createNode(generateId)(
    Node_Type.COLLAPSIBLE_ITEM_BODY,
    {},
    item.content.nodes
  )
]);
const toCollapsibleListNode = (generateId) => (data = DEFAULT_COLLAPSIBLE_LIST_DATA) => (nodes) => createNode(generateId)(
  Node_Type.COLLAPSIBLE_LIST,
  data,
  nodes
);
const toContentWithCollapsibleList = (args) => (node) => addNode({ ...args, node });
const makeCollapsibleList = (generateId) => ({
  items,
  data
}) => {
  return pipe(
    items,
    A.map(toCollapsibleItemNode(generateId)),
    toCollapsibleListNode(generateId)(data)
  );
};
const addCollapsibleList = (generateId) => ({
  items,
  data,
  index,
  before,
  after,
  content
}) => {
  return pipe(
    makeCollapsibleList(generateId)({ items, data }),
    toContentWithCollapsibleList({ index, before, after, content })
  );
};
export {
  addCollapsibleList,
  makeCollapsibleList
};
//# sourceMappingURL=collapsible-list-builder-api.js.map
